import React from "react";
import ReactDOM from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import "./index.css";
import App from "./App";

if (typeof window !== "undefined" && !window.__bookatherapyImageObserver) {
  const markImage = (img) => {
    if (
      img instanceof HTMLImageElement &&
      img.getAttribute("data-priority") !== "high"
    ) {
      if (!img.hasAttribute("loading")) {
        img.setAttribute("loading", "lazy");
      }
      if (!img.hasAttribute("decoding")) {
        img.setAttribute("decoding", "async");
      }
    }
  };

  document.querySelectorAll("img").forEach(markImage);

  const observer = new MutationObserver((mutationsList) => {
    mutationsList.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node instanceof HTMLElement) {
          if (node.tagName === "IMG") {
            markImage(node);
          } else {
            node.querySelectorAll?.("img").forEach(markImage);
          }
        }
      });
    });
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
  window.__bookatherapyImageObserver = observer;
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>,
);
